// extracted by mini-css-extract-plugin
export default {"wrapper":"ContentsLayout_wrapper__L2Oab"};